module.exports = __webpack_public_path__ + "img/en.db68882c.svg";